import React from "react";
import { Box, Typography, Modal, Grid } from "@material-ui/core";
import ButtonLoader from "./ButtonLoader";
export default function PaymentProcessingModal() {
  return (
    <Modal
      open={true}
      onClose={() => {}}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Box className="modal-wrapper">
        <Box className="modal">
          <div className="modal-heading">
            <div className="modal-heading-text">
              <Grid container spacing={2}>
                <Grid item>
                  <ButtonLoader />
                </Grid>
                <Grid item>
                  <Typography className="modal-title">決済処理中</Typography>
                </Grid>
              </Grid>
            </div>
          </div>
          <div className="modal-body">
            <div>
              <Typography
                style={{
                  fontSize: "1.4rem",
                  fontWeight: "800",
                  color: "var(--primary-color)",
                }}
              >
                ただいま処理中です。
                <br />
                完了画面が表示されるまでしばらくお待ちください。
              </Typography>
              <Typography>
                処理が完了するまでこの画面を閉じないでください。
              </Typography>
            </div>
          </div>
        </Box>
      </Box>
    </Modal>
  );
}
